import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { CtaBand } from "@/components/common/CtaBand";
import { BeforeAfterGallery } from "@/components/common/BeforeAfterGallery";
import { Seo } from "@/components/common/Seo";
import { buildBreadcrumbSchema } from "@/lib/schema";
import { TREATMENTS } from "@/data/site";
import { ToothIcon } from "@/components/common/ToothIcon";

export default function Treatments() {
  return (
    <div data-testid="treatments-page">
      <Seo
        title="Dental Treatments in Varanasi | Dr. Ankesh Seth"
        description="Explore comprehensive dental treatments in Varanasi — dental implants, root canal treatment, smile makeover, braces and more — all under one roof at Dr. Ankesh Seth's Paharia clinic."
        path="/treatments"
        jsonLd={buildBreadcrumbSchema([{ name: "Home", path: "/" }, { name: "Treatments", path: "/treatments" }])}
      />
      <PageHero
        eyebrow="Treatments"
        titleLines={["Complete Dental", "Treatments"]}
        subtitle="From routine cleanings to advanced implants and smile makeovers — comprehensive, modern dental care under one roof in Paharia, Varanasi."
        crumbs={[{ label: "Treatments" }]}
      />

      <section className="bg-white">
        <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32 lg:px-20">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {TREATMENTS.map((t, i) => (
              <Reveal key={t.slug} delay={(i % 3) * 0.06}>
                <Link
                  to={`/${t.slug}`}
                  data-testid={`treatment-item-${t.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-2xl border border-brand-line bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_30px_60px_-35px_rgba(2,125,199,0.5)]"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={t.image}
                      alt={`${t.name} in Varanasi — Dr. Ankesh Seth`}
                      loading="lazy"
                      width="640"
                      height="400"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-blue/10 text-brand-blue">
                      <ToothIcon className="h-5 w-5" />
                    </span>
                    <h3 className="mt-4 font-display text-2xl font-medium text-brand-dark">{t.name}</h3>
                    <p className="mt-2 flex-1 text-sm text-brand-muted">{t.short}</p>
                    <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-brand-blue">
                      Read More
                      <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <BeforeAfterGallery muted />
      <CtaBand />
    </div>
  );
}
